var render = function () {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c("NsHeaderProfileToggle", {
        attrs: {
          "dropdown-open": _vm.profilePopupOpen,
          greeting: _vm.translations.greeting,
          "hide-sign-up": _vm.hideSignUp,
          "sign-in-label": _vm.translations.signIn,
          "sign-up-label": _vm.translations.signUp,
        },
        on: { toggle: _vm.handleDropdownToggle },
      }),
      _vm._v(" "),
      _c("div", {
        class: [
          _vm.$style.triangle,
          ((_obj = {}),
          (_obj[_vm.$style.open] = _vm.profilePopupOpen),
          (_obj[_vm.$style.loggedIn] = _vm.isLoggedIn),
          _obj),
        ],
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.$style.popup,
            ((_obj$1 = {}),
            (_obj$1[_vm.$style.open] = _vm.profilePopupOpen),
            _obj$1),
          ],
        },
        [
          _c(
            "div",
            {
              class: [
                _vm.$style.content,
                ((_obj$2 = {}),
                (_obj$2[_vm.$style.loggedIn] = _vm.isLoggedIn),
                _obj$2),
              ],
              on: { mouseleave: _vm.handlePopupMouseleave },
            },
            [
              _c("NsHeaderProfile", {
                attrs: {
                  "hide-sign-up": _vm.hideSignUp,
                  "profile-menu": _vm.profileMenu,
                  "sign-out-url": _vm.signOutUrl,
                  "sign-up-url": _vm.signUpUrl,
                  translations: _vm.translations,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }